// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";

// import { useState, useEffect, useRef } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "../App.css";
import DevInfo from "./DevInfo";

export default function MobileDrawer() {
  return (
    <div className="mobile-menu">
      <button
        className="btn btn-lg d-md-none m-0 p-0 text-light"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#mobileDrawer"
        aria-controls="offcanvasExample"
        title="Menu"
      >
        <i className="fas fa-bars-staggered"></i>
      </button>

      <div
        className="offcanvas offcanvas-start"
        tabIndex="-1"
        id="mobileDrawer"
        aria-labelledby="offcanvasExampleLabel"
        data-bs-backdrop="static"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasExampleLabel">
            Developer Contact Card
          </h5>
          <button
            type="button"
            className="btn btn-lg animate__animated animate__flash closeDrawer"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="fas fa-circle-xmark"></i>
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="row align-items-center h-100">
            <div className="col-12">
              <DevInfo />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
